export enum RequestTypes {
	MissedClockOut = -8,
	MissedClockIn = -7,
	ContactsDependents = -6,
	AddressPhoneChange = -5,
	StateTaxWithholding = -4,
	FederalTaxWithholding = -3,
	AbsenceRequest = -2,
	TimesheetAdjustment = -1,
}
